<script setup>
 await navigateTo('/theater/performs')
</script>

<template>
  <div></div>
</template>
